

















































































































































































































































































































import vue from "vue";
import _ from "lodash";
import { Picker } from "emoji-mart-vue";
import {
  expiryTimeOptions,
  abandonedCheckoutTags,
  shippingConfirmationTags,
  defaultTags,
} from "../../helpers/consts";
import messagePreviewHelper from "../../helpers/messagePreviewHelper";
import MessageLength from "../MessageLength";
import MessageStrength from "../MessageStrength";
import { computed, onBeforeMount, onMounted, ref } from "@vue/composition-api";
import appBridge from "../../helpers/appBridge";

export default vue.extend({
  props: {
    campaign: Boolean,
    type: String,
    message: String,
    discount: {
      required: true,
      validator: (v) => true,
    },
    func: Function,
  },
  components: {
    Picker,
    MessageLength,
    MessageStrength,
  },
  setup(props: any, context: any): any {
    const tags = ref([]);
    const body = ref("");
    const showDiscounts = ref(true);
    const discountCodeOptions = ref([
      { label: "Do not add a discount code", value: "disable" },
      { label: "Use an existing discount code", value: "existing" },
      { label: "Create a unique discount code per text", value: "new" },
    ]);
    const discountValueTypeOptions = ref([
      { label: "Percentage", value: "percentage" },
      { label: "Free Shipping", value: "freeShipping" },
      { label: "Fixed Amount", value: "fixedValue" },
    ]);
    const discountMinimumRequirementsOptions = ref([
      { label: "None", value: "none" },
      { label: "Minimum purchase amount", value: "purchaseAmount" },
      { label: "Minimum quantity of items", value: "quantityItems" },
    ]);

    const existingDiscounts = computed(
      () => context.root.$store.state.shop.existingDiscounts
    );
    const shippingCountries = computed(
      () => context.root.$store.state.shop.shippingCountries
    );
    const store = computed(() => context.root.$store.state.store);

    const selectedDiscountCodeOption = ref("disable");
    const newDiscountConfiguration = ref({
      percentageDiscount: "",
      fixedDiscount: "",
      purchaseQuantity: "",
      minimumPurchaseAmount: "",
      freeShipping: "",
      validDuration: "604800s",
    });
    const existingDiscountCode = ref("");
    const minimumPurchaseAmount = ref("");
    const freeShipping = ref("");
    const purchaseQuantity = ref("");
    const discountValueType = ref("percentage");
    const discountMinimumRequirements = ref("none");
    const validForm = ref(true);
    const required = (value) => !!value || "Required";
    function formatDiscount(discount) {
      const messageDiscount = _.cloneDeep(discount);

      if (!messageDiscount.discount) {
        messageDiscount.discount = {};
      }
      // if the selected discount code options is set to existing
      if (
        discount.discountConfiguration.selectedDiscountCodeOption === "existing"
      ) {
        if (discount.discount.existingDiscountCode) {
          messageDiscount.discount.existingDiscountCode =
            discount.discount.existingDiscountCode;
          if (messageDiscount.discount.newDiscountConfiguration) {
            delete messageDiscount.discount.newDiscountConfiguration;
          }
        } else {
          delete messageDiscount.discount;
        }
      } else if (
        discount.discountConfiguration.selectedDiscountCodeOption === "new"
      ) {
        const newConfig = discount.discount.newDiscountConfiguration;
        // set valid duration
        if (
          discount.discountConfiguration.discountValueType === "freeShipping"
        ) {
          messageDiscount.discount = {
            newDiscountConfiguration: {
              freeShipping: {
                includeCountryIds: [newConfig.freeShipping],
              },
            },
          };
        } else if (
          discount.discountConfiguration.discountValueType === "percentage"
        ) {
          messageDiscount.discount = {
            newDiscountConfiguration: {
              percentageDiscount: parseInt(newConfig.percentageDiscount),
            },
          };
        } else if (
          discount.discountConfiguration.discountValueType === "fixedValue"
        ) {
          messageDiscount.discount = {
            newDiscountConfiguration: {
              fixedDiscount: {
                units: parseInt(newConfig.fixedDiscount),
                currencyCode: "USD",
                nanos: 0,
              },
            },
          };
        }

        if (
          discount.discountConfiguration.discountMinimumRequirements === "none"
        ) {
          if (
            messageDiscount.discount.newDiscountConfiguration
              .minimumRequirements
          ) {
            delete messageDiscount.discount.newDiscountConfiguration
              .minimumRequirements;
          }
        } else if (
          discount.discountConfiguration.discountMinimumRequirements ===
          "purchaseAmount"
        ) {
          if (
            messageDiscount.discount.newDiscountConfiguration
              .minimumRequirements
          ) {
            delete messageDiscount.discount.newDiscountConfiguration
              .minimumRequirements;
          }
          messageDiscount.discount.newDiscountConfiguration.minimumPurchaseAmount = {
            units: parseInt(
              discount.discount.newDiscountConfiguration.minimumPurchaseAmount
            ),
            currencyCode: "USD",
            nanos: 0,
          };
        } else if (
          discount.discountConfiguration.discountMinimumRequirements ===
          "quantityItems"
        ) {
          if (
            messageDiscount.discount.newDiscountConfiguration
              .minimumRequirements
          ) {
            delete messageDiscount.discount.newDiscountConfiguration
              .minimumRequirements;
          }

          messageDiscount.discount.newDiscountConfiguration.minimumPurchaseQuantity = parseInt(
            discount.discount.newDiscountConfiguration.purchaseQuantity
          );
        }

        if (newConfig.validDuration) {
          if (newConfig.validDuration === "null") {
            messageDiscount.discount.newDiscountConfiguration.validDuration = null;
          } else {
            messageDiscount.discount.newDiscountConfiguration.validDuration =
              newConfig.validDuration;
          }
        } else {
          delete messageDiscount.discount.newDiscountConfiguration
            .validDuration;
        }
      } else if (
        discount.discountConfiguration.selectedDiscountCodeOption === "disable"
      ) {
        if (messageDiscount.discount) {
          delete messageDiscount.discount;
        }
      }

      delete messageDiscount.discountConfiguration;
      return messageDiscount.discount;
    }

    function handleSave(val) {
      // @ts-ignore
      props.func({
        val: body.value,
        discount: formatDiscount({
          discount: {
            newDiscountConfiguration: newDiscountConfiguration.value,
            existingDiscountCode: existingDiscountCode.value,
          },
          discountConfiguration: {
            discountValueType: discountValueType.value,
            discountMinimumRequirements: discountMinimumRequirements.value,
            selectedDiscountCodeOption: selectedDiscountCodeOption.value,
          },
        }),
        formValid: val,
        config: {
          discountValueType: discountValueType.value,
          discountMinimumRequirements: discountMinimumRequirements.value,
          selectedDiscountCodeOption: selectedDiscountCodeOption.value,
        },
      });
    }

    onBeforeMount(() => {
      if (props.type === "ABANDONED_CHECKOUT") {
        tags.value = abandonedCheckoutTags;
      } else if (props.type === "SHIPPING_CONFIRMATION") {
        tags.value = shippingConfirmationTags;
      } else {
        tags.value = defaultTags;
      }
      // @ts-ignore
      body.value = props.message;

      if (props.discount) {
        if (props.discount.newDiscountConfiguration) {
          // @ts-ignore
          if (props.discount.newDiscountConfiguration.freeShipping) {
            freeShipping.value =
              // @ts-ignore
              props.discount.newDiscountConfiguration.freeShipping.includeCountryIds[0];
          }
          // @ts-ignore
          if (props.discount.newDiscountConfiguration.minimumPurchaseAmount) {
            minimumPurchaseAmount.value =
              // @ts-ignore
              props.discount.newDiscountConfiguration.minimumPurchaseAmount.units;
          }
          // @ts-ignore
          if (props.discount.newDiscountConfiguration.minimumPurchaseQuantity) {
            purchaseQuantity.value = JSON.stringify(
              // @ts-ignore
              props.discount.newDiscountConfiguration.minimumPurchaseQuantity
            );
          }

          selectedDiscountCodeOption.value = "new";
          newDiscountConfiguration.value.percentageDiscount = props.discount // @ts-ignore
            .newDiscountConfiguration.percentageDiscount
            ? JSON.stringify(
                // @ts-ignore
                props.discount.newDiscountConfiguration.percentageDiscount
              )
            : "";
          // @ts-ignore
          newDiscountConfiguration.value.freeShipping = freeShipping;

          (newDiscountConfiguration.value.fixedDiscount = props.discount // @ts-ignore
            .newDiscountConfiguration.fixedDiscount
            ? // @ts-ignore
              props.discount.newDiscountConfiguration.fixedDiscount.units
            : ""),
            // @ts-ignore
            (newDiscountConfiguration.value.minimumPurchaseAmount = minimumPurchaseAmount);
          // @ts-ignore
          newDiscountConfiguration.value.purchaseQuantity = purchaseQuantity;

          newDiscountConfiguration.value.validDuration = props.discount // @ts-ignore
            .newDiscountConfiguration.validDuration
            ? // @ts-ignore
              props.discount.newDiscountConfiguration.validDuration
            : "604800s";

          if (newDiscountConfiguration.value.percentageDiscount) {
            discountValueType.value = "percentage";
          } else if (newDiscountConfiguration.value.freeShipping) {
            discountValueType.value = "freeShipping";
          } else if (newDiscountConfiguration.value.fixedDiscount) {
            discountValueType.value = "fixedValue";
          }

          if (newDiscountConfiguration.value.minimumPurchaseAmount) {
            discountMinimumRequirements.value = "purchaseAmount";
          } else if (newDiscountConfiguration.value.purchaseQuantity) {
            discountMinimumRequirements.value = "quantityItems";
          } else {
            discountMinimumRequirements.value = "none";
          }
          // @ts-ignore
        } else if (props.discount.existingDiscountCode) {
          selectedDiscountCodeOption.value = "existing";
          // @ts-ignore
          existingDiscountCode.value = props.discount.existingDiscountCode;
        }
      } else {
        selectedDiscountCodeOption.value = "disable";
      }
    });

    onMounted(() => {
      const valid = context.refs.messageEditorForm.validate();
      handleSave(valid);
    });

    function addTag(val) {
      const textarea = document.getElementById("message");
      // @ts-ignore
      const cursorPosition = textarea.selectionEnd;
      // @ts-ignore
      const start = body.value.substring(0, textarea.selectionStart);
      // @ts-ignore
      const end = body.value.substring(textarea.selectionStart);
      const text = start + val.value + end;
      body.value = text;
      this.$nextTick(() => {
        // @ts-ignore
        textarea.selectionEnd = cursorPosition + val.value.length;
        const valid = context.refs.messageEditorForm.validate();
        textarea.focus();
        handleSave(valid);
      });
    }

    function addEmoji(val) {
      const textarea = document.getElementById("message");
      // @ts-ignore
      const cursorPosition = textarea.selectionEnd;
      // @ts-ignore
      const start = body.value.substring(0, textarea.selectionStart);
      // @ts-ignore
      const end = body.value.substring(textarea.selectionStart);
      const text = start + val.native + end;
      body.value = text;
      this.$nextTick(() => {
        // @ts-ignore
        textarea.selectionEnd = cursorPosition + val.native.length;
        const valid = context.refs.messageEditorForm.validate();
        handleSave(valid);
      });
    }

    function redirectTo(link) {
      appBridge(context.root.$store.state.store).redirectToRemote(link);
    }

    return {
      redirectTo,
      handleSave,
      existingDiscountCode,
      newDiscountConfiguration,
      minimumPurchaseAmount,
      freeShipping,
      purchaseQuantity,
      discountValueType,
      discountMinimumRequirements,
      expiryTimeOptions,
      existingDiscounts,
      shippingCountries,
      discountMinimumRequirementsOptions,
      discountValueTypeOptions,
      selectedDiscountCodeOption,
      discountCodeOptions,
      body,
      showDiscounts,
      addTag,
      addEmoji,
      tags,
      messagePreviewHelper,
      store,
      validForm,
      required,
    };
  },
});
